/**
* Icon Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Icon Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'icon-cards',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.icon-cards' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--icon-cards' )[0], {
          pagination: false,
          arrows: true,
          gap: '20px',
          perPage: 3,
          perMove: 1,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        splide.on( 'overflow', function( isOverflow ) {
          splide.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'icon-cards', COMPONENT );
} )( app );
